import { render, staticRenderFns } from "./KnowledgeRanking.vue?vue&type=template&id=112ff08a&scoped=true"
import script from "./KnowledgeRanking.vue?vue&type=script&lang=js"
export * from "./KnowledgeRanking.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeRanking.vue?vue&type=style&index=0&id=112ff08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112ff08a",
  null
  
)

export default component.exports